import { getFullUrl } from 'hubspot-url-utils';
export const getRootUrl = () => window.location.hostname.includes('hubspot') ? '/connect-public' : '';
export const getSignupUrl = queryString => {
  let signupUrl = `${getFullUrl('app')}/signup-hubspot/connect`;
  if (queryString) {
    signupUrl = `${signupUrl}?${queryString}`;
  }
  return signupUrl;
};